import React, { useMemo, useEffect, useState } from 'react'
import "./resultHeader.scss"
import { useSelector } from 'react-redux'
import { Select1dCurrentGameTime, Select1dLastWinCard, Select1dUserWallet, Select1dLastSaleAmount, Select1dLastTicketId } from '../../../redux/1d-slice/gameInfo1dSlice.js'
import moment from 'moment'
import TimerControl from './TimerControl'
import { AuthState } from "../../../context/AuthProvider";

function ResultHeader() {

    let currentDrawTime = useSelector(Select1dCurrentGameTime)
    let lastSaleAmount = useSelector(Select1dLastSaleAmount)
    let lastTicketId = useSelector(Select1dLastTicketId)
    let last_win_cards = useSelector(Select1dLastWinCard)
    const [timer, setTimer] = useState(null)

    let { userDetail } = AuthState()
    let userWallet = useSelector(Select1dUserWallet)

    useEffect(() => {
        let timeInterval = setInterval(() => {
            setTimer(moment().format('hh:mm:ss A'))
        }, 1000);

        return () => {
            clearInterval(timeInterval)
        }
    }, [])

    // Convert last_win_cards → [{num: 69, time: "06:00 PM"}, ...]
    let sortedCards = useMemo(() => {
        if (!last_win_cards?.length) return [];

        let arr = last_win_cards.map(card => {
            const [num, , time] = card.split("|");
            return {
                number: num,
                rawTime: time,
                momentTime: moment(time, "hh:mm A")
            };
        });

        // SORT BY TIME DESCENDING
        arr.sort((a, b) => b.momentTime - a.momentTime);

        return arr;
    }, [last_win_cards]);


    return (
        <>
        <style>
            
                {`.bg-color-1 { background: #f6a599; } .bg-color-2 { background: #f9ce8b; } .bg-color-3 { background: #f9c97e; } .bg-color-4 { background: #ffd45b; } .bg-color-5 { background: #fbd29c; } .bg-color-6 { background: #f29490; } .bg-color-7 { background: #f8abbb; } .bg-color-8 { background: #ec8258; } .bg-color-9 { background: #e2b438; } .bg-color-10 { background: #f28e8e; }`}
        </style>
            <table width="100%" className="hover-table">
                <tbody>
                    <tr>
                        <th
                            width="10%"
                            rowSpan={2}
                            className='result_head'
                            style={{
                                height: "30px !important", 
                                backgroundColor: "#d86b15", 
                                fontSize: '16px',
                                border: '1px solid black',
                            }}
                        >
                            Result: {currentDrawTime
                                ? moment(currentDrawTime, "DD/MM/YYYY, hh:mm:ss A")
                                    .subtract(5, "minutes")
                                    .format("hh:mm A")
                                : ""}

                            <br />
                            {currentDrawTime ? moment(currentDrawTime, 'D/M/yyyy, h:mm:ss A').format('D/M/yyyy') : ''}
                        </th>

                        {/* PRINT LAST WIN NUMBERS */}
                        {sortedCards.map((item, i) => (
                            <td
                                key={i}
                                className={`san_res_col text-center bg-color-${i + 1}`}
                                style={{
                                    fontSize: '24px',
                                    fontWeight: 'bold',
                                    color: 'black',
                                    
                                    border: '1px solid black',
                                }}
                            >
                                {item.number} <br />
                                <span style={{ fontSize: '14px', fontWeight: 'bold', color: 'black' }}>
                                    {item.rawTime
                                        ? moment(item.rawTime, "hh:mm:ss A").format("hh:mm A")
                                        : ""}
                                </span>
                            </td>
                        ))}


                    </tr>
                    <tr style={{
                        backgroundColor: "#eee8b4",
                    }}>
                        <th colSpan={2} scope="col" style={{ fontSize: '18px', border: '1px solid black', borderCollapse: 'collapse' }}>Time : {timer || '00:00:00'}</th>
                        <th colSpan={2} scope="col" style={{ fontSize: '18px', border: '1px solid black', borderCollapse: 'collapse' }}>Draw Time : {currentDrawTime ? moment(currentDrawTime, 'D/M/yyyy, h:mm:ss A').format('h:mm A') : ''}</th>
                        <th colSpan={2} scope="col" style={{ fontSize: '18px', border: '1px solid black', borderCollapse: 'collapse', color: 'red' }}>Time Left : <TimerControl /></th>
                        <th colSpan={1} scope="col" style={{ fontSize: '18px', border: '1px solid black', borderCollapse: 'collapse' }}>Id :{userDetail?.user_name || ''}</th>
                        <th colSpan={1} scope="col" style={{ fontSize: '18px', border: '1px solid black', borderCollapse: 'collapse' }}>Balance : {userWallet || 0}</th>
                        <th colSpan={1} scope="col" style={{ fontSize: '18px', border: '1px solid black', borderCollapse: 'collapse' }}>Last Trn : {lastTicketId || 0}</th>
                        <th colSpan={1} scope="col" style={{ fontSize: '18px', border: '1px solid black', borderCollapse: 'collapse' }}>Last Pts : {lastSaleAmount || 0}</th>


                    </tr>
                </tbody>
            </table>
        </>
    )
}

export default ResultHeader
